import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';
import _debounce from 'lodash/debounce';
import cx from 'classnames';
import { openModal } from 'cards/actions/modalActions';
import RemoveIcon from 'assets/images/icons/remove.svg';
import { FILTER_KEYS } from 'cards/components/CardListing/CardListingRedesign/CardListingFilter/constants';

import styles from './styles.module.less';

const FilterMobileMenu = ({
  activeFilters,
  updateFilter,
  content: Component,
  optionList,
  clearValue,
  filterStateKey,
  filterList,
  showModal,
  title,
  hideModalFn,
}) => {
  const [windowInnerHeight, setWindowInnerHeight] = useState(window.innerHeight);
  const [localFilters, setLocalFilters] = useState({
    ...activeFilters,
  });

  const noLocalFilterSelected =
    filterList.filter(filterKey => {
      const currentValue = localFilters[filterKey];
      return FILTER_KEYS[filterKey].existenceCheck(currentValue);
    }).length < 1;

  useEffect(() => {
    setLocalFilters({
      ...activeFilters,
    });
  }, [activeFilters]);

  function updateLocalFilter(key, val) {
    setLocalFilters({
      ...localFilters,
      [key]: val,
    });
  }

  function applyFilter() {
    filterList.map(filterKey => updateFilter(filterKey, localFilters[filterKey]));
    hideModalFn();
  }

  function clearLocalFilters() {
    setLocalFilters({
      ...localFilters,
      ...clearValue,
    });
  }

  useEffect(() => {
    const handleResize = _debounce(() => {
      setWindowInnerHeight(window.innerHeight);
    }, 100);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={styles.modalContainer} style={{ height: `${windowInnerHeight}px` }}>
      <div className={styles.modalHeader}>
        <ButtonV2
          className={cx(styles.clearBtn, {
            [styles.clearBtnDisabled]: noLocalFilterSelected,
          })}
          variant="secondary"
          onClick={clearLocalFilters}
          disabled={noLocalFilterSelected}
        >
          Clear
        </ButtonV2>
        <div className={styles.modalTitle}>{title}</div>
        <ButtonV2 className={styles.closeBtn} variant="secondary" onClick={hideModalFn}>
          <img src={RemoveIcon} alt="close" />
        </ButtonV2>
      </div>
      <div className={styles.modalDescription}>
        <Component
          optionList={optionList}
          activeFilters={localFilters}
          updateFilter={updateLocalFilter}
          activeValue={localFilters[filterStateKey]}
          showModal={showModal}
        />
      </div>
      <div className={styles.modalAction}>
        <ButtonV2 className={styles.applyBtn} onClick={applyFilter}>
          Apply
        </ButtonV2>
      </div>
    </div>
  );
};

FilterMobileMenu.propTypes = {
  hideModalFn: PropTypes.func.isRequired,
  activeFilters: PropTypes.shape({
    multiColor: PropTypes.array,
    motifs: PropTypes.array,
    has_foil: PropTypes.bool,
    has_custom_photo: PropTypes.bool,
    has_no_custom_photo: PropTypes.bool,
    has_digital: PropTypes.bool,
    has_magnet: PropTypes.bool,
    is_letterpress: PropTypes.bool,
    is_vow_renewal: PropTypes.bool,
  }),
  updateFilter: PropTypes.func.isRequired,
  content: PropTypes.func,
  optionList: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape()])),
  // reset value for specific filter array, false, null
  clearValue: PropTypes.shape({}),
  filterStateKey: PropTypes.string,
  filterList: PropTypes.arrayOf(PropTypes.string).isRequired,
  showModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  showModal: (modalType, modalProps, modalOptions) =>
    dispatch(openModal(modalType, modalProps, modalOptions)),
});

export default connect(null, mapDispatchToProps)(FilterMobileMenu);



// WEBPACK FOOTER //
// ./src/cards/components/CardListing/CardListingRedesign/CardListingFilter/FilterMobileMenu/FilterMobileMenu.jsx